module.exports = __webpack_public_path__ + "static/img/pro2.b47da83.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/base/pro2.png
// module id = 1647
// module chunks = 2